import React from "react";
import useHintRecorder from "./useHintRecorder";
import { MicFill, StopFill } from "react-bootstrap-icons";

interface HintAudioProps {
  fileId: number;
  refetchAudioList?: () => void;
  page: string;
}

export const HintAudio: React.FC<HintAudioProps> = ({ fileId, refetchAudioList, page }) => {
  const { audioURL, isRecording, startRecording, stopRecording, timer, isUploading } =
    useHintRecorder({ fileId, refetchAudioList, page });

  const formatTimer = (seconds: number) => {
    const min = Math.floor(seconds / 60);
    const sec = String(seconds % 60).padStart(2, "0");
    return `${min}:${sec}`;
  };

  return (
    <div className="p-3">
      {/* Recorded audio preview */}
      {audioURL && (
        <div className="mb-3">
          <audio src={String(audioURL)} controls className="w-100" />
        </div>
      )}

      {/* Timer */}
      {isRecording && (
        <span className="mb-5">
          🔴 Recording... {formatTimer(timer)}
        </span>
      )}

      {isUploading && <span className="mb-5">Saving...</span>}

      {/* Controls */}
      <div className="d-flex justify-content-center gap-3">
        <button
          style={{ width: '40px', height: "40px", padding: "0px" }}
          onClick={startRecording}
          disabled={isRecording}
          className={`btn btn-success btn-md rounded-circle shadow ${isRecording ? "disabled" : ""}`}
        >
          <MicFill size={18} />
        </button>

        <button
          style={{ width: '40px', height: "40px", padding: "0px" }}
          onClick={stopRecording}
          disabled={!isRecording}
          className={`btn btn-danger btn-md rounded-circle shadow ${!isRecording ? "disabled" : ""}`}
        >
          <StopFill size={18} />
        </button>
      </div>
    </div>
  );
};